import React from 'react'
import { BaseComponentProps } from '../types'

const Arrow2Icon: React.FC<BaseComponentProps> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
    >
      <path d='M11.333 6.66667L7.99967 10L4.66634 6.66667L11.333 6.66667Z' fill='#191C1F' />
    </svg>
  )
}

export default Arrow2Icon
